<template>
  <div>
    <div class="info-box">
      <div class=" dont-insure">
        <h2>We don't insure</h2>
        <ul class="warning-list">
          <li>Heavily modified cars</li>
          <li>Classic cars</li>
          <li>Driver's with criminal convictions</li>
          <li>Exotic cars (e.g. Ferrari, Lamborghini)</li>
          <li>Vehicles worth more than $150,000</li>
        </ul>
      </div>
    </div>

    <br />

    <div class="box">
      <p><a href="#" class="modal-title" @click.prevent="toggleModal('modalNoRegistrationOpen')">No car registration yet?</a></p>
      <modal
          v-if="this.modalNoRegistrationOpen"
          :class="{ 'is-active': modalNoRegistrationOpen }"
          v-on:childToParent="toggleModal('modalNoRegistrationOpen')"
          title="No car registration yet?">

        <div class="content">
          <p>If you have purchased a brand new car but are still waiting on registration, we may be able to help you get a quote and cover.</p>
          <p>Email us at <a href="mailto:info@initio.co.nz">info@initio.co.nz</a> with your car details.</p>
        </div>
      </modal>
      <hr />
      <p><a href="#" class="modal-title" @click.prevent="toggleModal('modalCarCoverOpen')">Who's covered to drive my car?</a></p>
      <modal
          v-if="this.modalCarCoverOpen"
          :class="{ 'is-active': modalCarCoverOpen }"
          v-on:childToParent="toggleModal('modalCarCoverOpen')"
          title="Who's covered to drive my car?">

        <div class="content">
          <p>You only need to tell us the name of your main driver i.e. the person who drives the vehicle the most.</p>
          <p>All other drivers will be automatically covered provided that they meet your policy conditions, such as driving within their license requirements.</p>
          <p>If you select the optional discount to exclude drivers under 25 years old, no cover will be provided for drivers unless they are 25 or over.</p>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>


export default {
  components: {
    
  },
  methods: {
    toggleModal: function (type) {
      switch (type){
        case "modalNoRegistrationOpen":
          this.modalNoRegistrationOpen = ! this.modalNoRegistrationOpen
          break;
        case "modalCarCoverOpen":
          this.modalCarCoverOpen = ! this.modalCarCoverOpen
          break;
      }
    }
  },
  data: function () {
      return {
        modalNoRegistrationOpen: false,
        modalCarCoverOpen: false
      }
  },
  name: 'initio-dont-insure'
}

</script>

<style scoped lang="scss">
  ul.warning-list {
    padding: 0;
    margin: 1rem 0;

    li {
      line-height: 1.3rem;
      padding-left: 1rem;
      color: $grey-text;
      padding: 0;
      display: flex;
      margin-bottom: 0.6rem;

      &:before {
        content: "";
        width: 16px;
        height: 16px;
        margin-top: 0.1rem;
        background-size: auto;
        background-repeat: no-repeat;
        background-image: url("data:image/svg+xml;utf8,<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M8 0C3.58754 0 0 3.58754 0 8C0 12.4125 3.58754 16 8 16C12.4125 16 16 12.4125 16 8C16 3.58754 12.4125 0 8 0ZM11.0651 9.76842C11.419 10.1224 11.419 10.7118 11.0651 11.0651C10.8796 11.2507 10.6612 11.3349 10.425 11.3349C10.1894 11.3349 9.95325 11.2507 9.78483 11.0651L7.9999 9.29671L6.23148 11.0651C6.04595 11.2507 5.82754 11.3349 5.59134 11.3349C5.35582 11.3349 5.11963 11.2507 4.95121 11.0651C4.59726 10.7112 4.59726 10.1217 4.95121 9.76842L6.70312 8L4.9347 6.23158C4.58075 5.87763 4.58075 5.28815 4.9347 4.93487C5.28866 4.58092 5.87813 4.58092 6.23141 4.93487L7.99983 6.70329L9.76825 4.93487C10.1222 4.58092 10.7117 4.58092 11.065 4.93487C11.4189 5.28883 11.4189 5.8783 11.065 6.23158L9.29654 8L11.0651 9.76842Z' fill='%23B54141'/></svg>");

        display: inline-block;
        text-align: left;
        padding-right: 1.5rem;
        line-height: 1rem;
        vertical-align: text-bottom;
      }
    }
  }
  
  hr {
    border:0;
    border-top:1px solid $light-grey;
    background:none;
    margin:0.5rem 0;
  }

  .box {
    padding:1rem;
    .modal-title {
      font-size:0.875rem;
    }
  }

</style>